import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import Axios from "../axios";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import RateType from "./rateTypeList";
import Region from "./regionList";
import Chain from "./chainList";
import TopHotels from "./top20Hotels";
import DailySales from "./dailySales";
import { Helmet } from "react-helmet";
import DownloadIcon from "@mui/icons-material/Download";

const SliceAndDice = () => {
  const location = useLocation();
  const [allTrip, setAllTrip] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};
  const [value, setValue] = useState("1");

  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  const [totals, setTotals] = useState({
    totalGrossBookings: 0,
    totalNetBookings: 0,
  });
  //header for the CSv file
  const headers = [
    { label: "Supplier Name", key: "providerName" },
    { label: "Gross bookings", key: "allBookingsCount" },
    { label: "Net bookings", key: "confirmedBookingsCount" },
    { label: "Cancelled bookings", key: "failedBookingsCount" },
    { label: "Gross Revenue", key: "totalRateBookings" },
    { label: "Net Revenue", key: "totalRateConfirmedBookings" },
    { label: "Cancelled Revenue", key: "totalRateFailedBookings" },
    { label: "Gross Room nights", key: "totalRoomCount" },
    { label: "Net Room nights", key: "totalConfirmedRoomCount" },
    { label: "Cancelled Room nights", key: "totalFailedRoomCount" },
    { label: "Avg daily Revenue", key: "DailyBooking" },
    { label: "% Sales based on revenue", key: "proportionRevenue" },
    { label: "% Sales based on bookings", key: "proportions" },
  ];

  useEffect(() => {
    if (passedValue) {
      fetchAllTrip(0, "", passedValue);
    } else {
      fetchAllTrip(0, "", "");
    }
    handleDownloadProcess();
  }, [passedValue]);

  const fetchAllTrip = (page, search, id) => {
    let data = {
      page: page,
      searchChar: search,
      userID: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-suppliers", data)
      .then((resp) => {
        setAllTrip(resp?.data?.data);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-suppliers")
      .then((resp) => {
        const fetchedData = resp?.data?.data || [];

        // Calculate Totals
        const totalGrossBookings = fetchedData.reduce(
          (sum, item) => sum + (item.allBookingsCount || 0),
          0
        );
        const totalNetBookings = fetchedData.reduce(
          (sum, item) => sum + (item.confirmedBookingsCount || 0),
          0
        );
        const totalCancelledBookings = fetchedData.reduce(
          (sum, item) => sum + (item.failedBookingsCount || 0),
          0
        );

        const totalGrossRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateBookings || 0),
          0
        );
        const totalNetRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateConfirmedBookings || 0),
          0
        );
        const totalCancelRevenue = fetchedData.reduce(
          (sum, item) => sum + (item.totalRateFailedBookings || 0),
          0
        );
        const totalGrossRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalRoomCount || 0),
          0
        );
        const totalNetRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalConfirmedRoomCount || 0),
          0
        );
        const totalCancelledRoomNights = fetchedData.reduce(
          (sum, item) => sum + (item.totalFailedRoomCount || 0),
          0
        );

        setTotals({
          totalGrossBookings,
          totalNetBookings,
          totalCancelledBookings,
          totalGrossRevenue,
          totalNetRevenue,
          totalCancelRevenue,
          totalGrossRoomNights,
          totalNetRoomNights,
          totalCancelledRoomNights,
        });

        // Add totals row to the CSV data
        const dataWithTotals = [
          ...fetchedData,
          {
            providerName: "Total",
            allBookingsCount: totalGrossBookings,
            confirmedBookingsCount: totalNetBookings,
            failedBookingsCount: totalCancelledBookings,
            totalRateBookings: totalGrossRevenue,
            totalRateConfirmedBookings: totalNetRevenue,
            totalRateFailedBookings: totalCancelRevenue,
            totalRoomCount: totalGrossRoomNights,
            totalConfirmedRoomCount: totalNetRoomNights,
            totalFailedRoomCount: totalCancelledRoomNights, // Leave other fields blank or calculate if needed
          },
        ];

        setDownloadData(dataWithTotals);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Error fetching supplier data."
        );
      });
  };

  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllTrip(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllTrip(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"supplier.csv"}
            >
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const columns = [
    {
      name: "providerName",
      label: "Supplier Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "allBookingsCount",
      label: "Gross bookings",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "confirmedBookingsCount",
      label: "Net bookings",

      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "failedBookingsCount",
      label: "Cancelled bookings",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "totalRateBookings",
      label: "Gross Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(allTrip[dataIndex]?.totalRateBookings).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },

    {
      name: "totalRateConfirmedBookings",
      label: "Net Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(
                  allTrip[dataIndex]?.totalRateConfirmedBookings
                ).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },
    {
      name: "totalRateFailedBookings",
      label: "Cancelled Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(
                  allTrip[dataIndex]?.totalRateFailedBookings
                ).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },

    {
      name: "totalRoomCount",
      label: "Gross Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: "totalConfirmedRoomCount",
      label: "Net Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "totalFailedRoomCount",
      label: "Cancelled Room nights",
      options: {
        filter: false,
        sort: false,
      },
    },

    {
      name: "DailyBooking",
      label: "Avg daily Revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>{parseFloat(allTrip[dataIndex]?.DailyBooking).toFixed(2)}</p>
            </>
          );
        },
      },
    },
    {
      name: "proportionRevenue",
      label: "% Sales based on revenue",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>
                {parseFloat(allTrip[dataIndex]?.proportionRevenue).toFixed(2)}
              </p>
            </>
          );
        },
      },
    },
    {
      name: "proportions",
      label: "% Sales based on bookings",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <p>{parseFloat(allTrip[dataIndex]?.proportions).toFixed(2)}</p>
            </>
          );
        },
      },
    },
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "1") {
      if (passedValue) {
        fetchAllTrip(0, "", passedValue); // Use `passedValue` if it exists
      } else {
        fetchAllTrip(0, "", ""); // Default behavior
      }
    }
  };

  const handleChangeExplore = (event, tripId, type) => {
    handleStatus(tripId, type); // Pass the checked state and tripId
  };
  const handleStatus = (id, type) => {
    let api;
    let data = {
      id: id,
      userID: passedValue ? passedValue : "",
    };
    if (type === "explore") {
      api = "update-explore-trips";
    } else {
      api = "update-feature-trip";
    }
    Axios.post(process.env.REACT_APP_BACKEND + api, data)
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-Slice and Dice</title>
        <meta name="Trip List" content="Trip List for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-2">
        <h2>Slice and Dice</h2>
      </div>

      <Tabs
        value={value}
        onChange={handleChange}
        className="mb-4"
        sx={{
          "& button": {
            borderRadius: 2,
            color: "#000", // Default text color
            transition: "all 0.3s", // Smooth transition
          },
          "& button:hover": {
            color: "#3dd2cc", // Hover color
          },
          "& button.Mui-selected": {
            color: "#3dd2cc", // Active tab color
            fontWeight: "bold", // Optional: Make active tab bold
            // backgroundColor: "rgba(61, 210, 204, 0.1)", // Light background for active
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "black", // Change underline color
          },
        }}
      >
        <Tab
          className="fs-14 fw-600 p-2 mr-2"
          value="1"
          label="Supplier Sales"
        />
        {/* <Tab className="fs-14 fw-600 p-2 mr-2" value="2" label="Rate Type" /> */}
        <Tab className="fs-14 fw-600 p-2 mr-2" value="3" label="Region" />
        <Tab className="fs-14 fw-600 p-2 mr-2" value="4" label="Chain" />
        <Tab
          className="fs-14 fw-600 p-2 mr-2"
          value="5"
          label="Top 20 Hotels"
        />
        {/* <Tab className="fs-14 fw-600 p-2 mr-2" value="6" label="Daily Sales" /> */}
      </Tabs>
      {value === "1" ? (
        <MUIDataTable
          title={"Supplier List"}
          data={allTrip}
          columns={columns}
          options={options}
        />
      ) : value === "2" ? (
        <RateType />
      ) : value === "3" ? (
        <Region />
      ) : value === "4" ? (
        <Chain />
      ) : value === "5" ? (
        <TopHotels />
      ) : value === "6" ? (
        <DailySales />
      ) : null}
    </>
  );
};
export default SliceAndDice;
